import { render, staticRenderFns } from "./SideMenuEntry.vue?vue&type=template&id=5f50a644&scoped=true&"
import script from "./SideMenuEntry.vue?vue&type=script&lang=js&"
export * from "./SideMenuEntry.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuEntry.vue?vue&type=style&index=0&id=5f50a644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50a644",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BNavItem} from 'bootstrap-vue'
    installComponents(component, {BNavItem})
    

export default component.exports